import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({ selector: '[scUppercase]' })
export class UppercaseDirective {
  @Input() enabled: boolean;
  constructor(private _el: ElementRef) {}
  @HostListener('input', ['$event'])
  onKeyUp(event) {
    if (!this.enabled) {
      return;
    }
    this._el.nativeElement.value = this._el.nativeElement.value.toUpperCase();
  }
}
